import { BaseService, Service } from "/@/cool";

@Service("baseAppSpaceInfo")
class SpaceInfo extends BaseService {}

export default SpaceInfo;
